module.exports = __webpack_public_path__ + "static/Himbeere-9212014612848f79122d614b708164ea.png";